<template>
  <section class="messaging-protection">
    <h1>Messaging Protection</h1>
    <p>Separate evaluation from active release protection for outgoing messages.</p>
    <nav aria-label="Messaging protection categories" class="protection-nav">
      <RouterLink :to="{ name: STAFF_PUMPING_PROTECTION }">
        Pumping Protection <span>Evaluation</span>
      </RouterLink>
      <RouterLink :to="{ name: STAFF_DEPLOYMENT_PROTECTION }">
        Deployment Protection <span>Active protection</span>
      </RouterLink>
    </nav>
    <RouterView />
  </section>
</template>

<script setup lang="ts">
import { RouterLink, RouterView } from 'vue-router'
import { STAFF_DEPLOYMENT_PROTECTION, STAFF_PUMPING_PROTECTION } from '@/types/router'
</script>

<style scoped lang="scss">
.protection-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin: 24px 0;
  a {
    display: flex;
    align-items: center;
    gap: 12px;
    min-height: 48px;
    padding: 12px 20px;
    color: variables.$dark-green;
    background: variables.$white;
    border: 1px solid variables.$beige;
    border-radius: variables.$border-radius;
    text-decoration: none;
    span { font-size: 12px; }
    &.router-link-active { border: 2px solid variables.$dark-green; font-weight: 600; }
    &:focus-visible { outline: 2px solid variables.$green; outline-offset: 3px; }
  }
}
</style>
